'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CookieBar = CookieBar;
var el = void 0;
var settings = void 0;
var cookieDeclineBtn = void 0;
var cookieSettingsCloseBtn = void 0;

function CookieBar() {
    el = document.querySelector('.js-cookie');
    if (!el) {
        return;
    }

    settings = el.querySelector('.js-cookie-settings');
    cookieDeclineBtn = el.querySelector('.js-cookie-decline');
    cookieSettingsCloseBtn = el.querySelector('.js-cookie-settings-close');

    if (cookieDeclineBtn) {
        cookieDeclineBtn.addEventListener('click', openSettings);
    }

    document.addEventListener('keydown', function (evt) {
        if (evt.key !== 'Escape') {
            return;
        }

        closeSettings();
    });

    if (cookieSettingsCloseBtn) {
        cookieSettingsCloseBtn.addEventListener('click', closeSettings);
    }
}

function openSettings(evt) {
    evt.preventDefault();
    settings.classList.add('is-active');
    cookieSettingsCloseBtn.focus();
}

function closeSettings(evt) {
    evt.preventDefault();
    settings.classList.remove('is-active');
    cookieDeclineBtn.focus();
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/ui/cookie.js
// module id = ./resources/assets/js/src/ui/cookie.js
// module chunks = 0